import "./StaticPages.css";

export default function Terms() {
  return (
    <div className="static-page">
      <h1>Terms & Conditions</h1>
      <p className="lead">Last updated: {new Date().toLocaleDateString("en-IN", { month: "long", year: "numeric" })}</p>

      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>By accessing and using NovaStore ("the Service"), you agree to be bound by these Terms and Conditions. If you do not agree, please do not use our Service.</p>
      </section>

      <section>
        <h2>2. Account Registration</h2>
        <p>You must provide accurate and complete information during registration. You are responsible for maintaining the security of your account credentials. One account per person — multiple accounts may be suspended. You must be at least 13 years old to use our Service.</p>
      </section>

      <section>
        <h2>3. Orders & Payments</h2>
        <p>All prices are listed in Indian Rupees (₹) and are inclusive of applicable taxes. Orders are processed using your wallet balance. Add money via UPI to fund your wallet. Once an order is placed and fulfilled, it cannot be reversed as in-game items are delivered instantly. Prices may change without prior notice due to provider rate changes.</p>
      </section>

      <section>
        <h2>4. Refund Policy</h2>
        <p>Refunds are issued to your wallet balance (not to your bank account). If an order fails to deliver due to a system error, a full refund will be processed automatically. If you provided incorrect game credentials (User ID, Zone ID), we cannot guarantee a refund. Refund requests must be raised within 24 hours of the transaction. Contact our support team for refund assistance.</p>
      </section>

      <section>
        <h2>5. Wallet</h2>
        <p>Wallet balance is non-transferable between accounts. Wallet balance cannot be withdrawn to a bank account. Fraudulent wallet top-ups will result in immediate account suspension.</p>
      </section>

      <section>
        <h2>6. Prohibited Activities</h2>
        <p>You agree not to use automated scripts or bots to access the Service, attempt to exploit vulnerabilities or bypass security measures, use stolen payment methods or engage in fraudulent transactions, resell services without authorization, or abuse the referral or promotional systems.</p>
      </section>

      <section>
        <h2>7. Account Suspension</h2>
        <p>We reserve the right to suspend or terminate accounts that violate these Terms, engage in fraudulent activity, or abuse our Service. Suspended accounts may forfeit their wallet balance.</p>
      </section>

      <section>
        <h2>8. Limitation of Liability</h2>
        <p>NovaStore acts as an intermediary between you and game currency providers. We are not affiliated with the game publishers. We are not responsible for delays caused by third-party providers, changes to in-game pricing or availability by game publishers, or loss of access to your game account.</p>
      </section>

      <section>
        <h2>9. Changes to Terms</h2>
        <p>We may modify these Terms at any time. Continued use of the Service constitutes acceptance of the updated Terms.</p>
      </section>

      <section>
        <h2>10. Contact</h2>
        <p>For questions about these Terms, contact us at <a href="mailto:support@novaofficial.in">support@novaofficial.in</a>.</p>
      </section>
    </div>
  );
}